module.exports = __webpack_public_path__ + "img/previous_exam_papers.489e09f3.svg";